import { Header, PrimaryButton, Spacer, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import SuccessIcon from './assets/csv-import-success.png'
import { type IImporterModifiedRowCounts } from '../../LegacyImporter'
import messages from '../../messages'
import { ImporterContentStyled as Content } from '../../styles/ImporterContentStyled'

export interface IImporterSuccessStageProps {
  itemName: string
  modifiedRowCounts: IImporterModifiedRowCounts
  onDismiss?: () => void
}

export const ImporterSuccessStage = ({
  itemName = 'items',
  modifiedRowCounts,
  onDismiss,
}: IImporterSuccessStageProps) => {
  const intl = useProcurifyIntl()
  const { CREATE, DEACTIVATE, IGNORE, UPDATE } = modifiedRowCounts

  return (
    <Content width={480}>
      <Header as='h3' gutter>
        {intl.formatMessage(messages.successStepTitle)}
      </Header>
      <img
        alt={intl.formatMessage(messages.successStepAltLabel)}
        src={SuccessIcon}
        height={130}
      />
      <Spacer />

      {CREATE > 0 && (
        <div>
          <Text inline bold>
            {CREATE} {itemName}
          </Text>{' '}
          <Text inline>
            {intl.formatMessage(messages.successCreatedDescription)}
          </Text>
        </div>
      )}

      {DEACTIVATE > 0 && (
        <div>
          <Text inline bold>
            {DEACTIVATE} {itemName}
          </Text>{' '}
          <Text inline>
            {intl.formatMessage(messages.successDeactivatedDescription)}
          </Text>
        </div>
      )}

      {IGNORE > 0 && (
        <div>
          <Text inline bold>
            {IGNORE} {itemName}
          </Text>{' '}
          <Text inline>
            {intl.formatMessage(messages.successIgnoredDescription)}
          </Text>
        </div>
      )}

      {UPDATE > 0 && (
        <div>
          <Text inline bold>
            {UPDATE} {itemName}
          </Text>{' '}
          <Text inline>
            {intl.formatMessage(messages.successUpdatedDescription)}
          </Text>
        </div>
      )}

      <Spacer space={2} />

      <PrimaryButton onClick={onDismiss}>
        {intl.formatMessage(messages.successStepDoneButton)}
      </PrimaryButton>
    </Content>
  )
}
